var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default"),(_vm.target==='_blank')?_c('font-awesome-icon',{staticClass:"ml-2",attrs:{"icon":['far', 'external-link-alt'],"size":"1x"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }